import { render } from "./zone-detail.vue?vue&type=template&id=488b4bae&scoped=true"
import script from "./zone-detail.vue?vue&type=script&lang=js"
export * from "./zone-detail.vue?vue&type=script&lang=js"

import "./zone-detail.vue?vue&type=style&index=0&id=488b4bae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-488b4bae"]])

export default __exports__